var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"crowded"}},[_c('div',{staticClass:"crowded-box"},[_c('img',{attrs:{"src":require("@/assets/img/Special/stock.png")}}),_c('h1',[_vm._v("暂时缺货中")]),_c('div',[_vm._v(" 活动太火爆目前缺货中，预计3个工作日 内补货完成，请您后续再兑换 ")])])])
}]

export { render, staticRenderFns }